// extracted by mini-css-extract-plugin
export var container = "_4k-0";
export var icon = "_4k-1";
export var text = "_4k-2";